import styled from 'styled-components/native';

export default styled.ActivityIndicator.attrs(({ theme }) => ({
  size: 53,
  color: theme.colors.text,
}))``;
